import { bidAndWinActions } from 'actions/GamificationActions/bidAndWinActions';
import { INIT } from 'utils/asyncStatusHelper';
import { createReducer } from 'utils/reducerUtils';
export default createReducer(bidAndWinActions.GET_BID_AND_WIN_WINNERS_REQUEST, bidAndWinActions.GET_BID_AND_WIN_WINNERS_SUCCESS, bidAndWinActions.GET_BID_AND_WIN_WINNERS_ERROR, {
    asyncStatus: INIT,
    data: []
});
